import React, { Component, createRef } from "react";
import "component/listItem/CategoryType2/styles.scss";
import bannerDefault from "assets/images/bannerDefault.png";
import { ReactComponent as TrophyIcon } from "assets/icons/Tournament.svg";
import { ReactComponent as RibbonIcon } from "assets/icons/FreeRounds.svg";
import { ReactComponent as EditorsChoiceIcon } from "assets/icons/editors-badge.svg";
import { ReactComponent as CrownIcon } from "assets/icons/Jackpot.svg";
import { setDefaultImageFormat } from "utils/image";
import { getTotalPool } from "utils/getTotalpool";

const ICON_DEFAULT = "ICON_DEFAULT";

class CategoryType2 extends Component {
  constructor(props) {
    super(props);
    this.onMouseOverHandler = this._onMouseOverHandler.bind(this);
    this.getTotalPool = getTotalPool.bind(this);
    this.mainComponent = createRef();
    this.state = {
      hovered: false,
      isVisible: false,
      hasPromotionIcons: false,
      jackpotPool: null,
    };
  }

  _onMouseOverHandler(bol) {
    this.setState({
      hovered: bol,
    });
  }

  componentDidMount() {
    this.initObserver();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.game && nextProps.game !== this.props.game) {
      let hasPromotionIcons;
      nextProps.game.get("hasFreeRounds") ||
        nextProps.game.get("partOfOnGoingTournament") ||
        nextProps.game.get("isFeatured") ||
        nextProps.game.get("isJackpot");
      this.setState({
        hasPromotionIcons,
      });
    }

    if (
      nextProps.latestBroadcast &&
      nextProps.latestBroadcast.get("jackpotGroupId") ===
        this.props.game.get("jackpotGroupId")
    ) {
      let latestJackpotPool;
      latestJackpotPool = {
        type: nextProps.latestBroadcast.get("type"),
        amount: nextProps.latestBroadcast.get("amount"),
      };
      this.setState({
        jackpotPool: {
          ...this.state.jackpotPool,
          [latestJackpotPool.type]: { amount: latestJackpotPool.amount },
        },
      });
    } else {
      this.setState({ jackpotPool: null });
    }
  }

  initObserver() {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.mainComponent.current) {
                this.setState({
                  isVisible: true,
                });
              }
            } else {
              if (this.mainComponent.current) {
                //clearInterval(this.initLoadDelay)
              }
            }
          });
        },
        {
          //rootMargin: '500px 0px 500px 0px'
          rootMargin: "0px 0px 0px 0px",
        }
      );
      observer.observe(this.mainComponent.current);
    } else {
      //this.getGames(this.props.link);
      //this.getTournamentPreview(this.props.links)
    }
  }

  renderSkeleton() {
    return (
      <div>
        <img src={bannerDefault} className="icon" alt="name" />
        <div className="details">
          <div className="name">
            <span className="dummy">XXXXXXXXXXX</span>
          </div>
          <div className="provider">
            <span className="dummy">XXXXXXXXXXX</span>
          </div>
          <div className="game-type">
            <span className="dummy">XXXXXXXXXXX</span>
          </div>
        </div>
      </div>
    );
  }

  render() {
    let { game } = this.props;

    return (
      <div
        className={`${this.props.className} category-type-2`}
        onMouseOver={() => {
          this.onMouseOverHandler(true);
        }}
        onMouseOut={() => {
          this.onMouseOverHandler(false);
        }}
        onClick={(event) => {
          if (this.props.onClick) {
            this.props.onClick(this.props.linkDetails.get("rel"));
          }
          event.stopPropagation();
        }}
        ref={this.mainComponent}
      >
        {!game && this.renderSkeleton()}
        {game && (
          <div>
            <div className="img-holder">
              {this.state.isVisible && (
                <img
                  src={`${setDefaultImageFormat(
                    game.getIn(["images", "url"]) + "&width=450&theme=dark",
                    this.props.imageFormat.get("banner")
                  )}`}
                  className="icon d-none"
                  alt={game.get("name")}
                  onLoad={({ currentTarget }) => {
                    currentTarget.classList.remove("d-none");
                    this.refs[ICON_DEFAULT].classList.add("d-none");
                  }}
                />
              )}
              <img
                ref={ICON_DEFAULT}
                src={bannerDefault}
                className="icon"
                alt={game.get("name")}
              />
              {game && game.get("jackpotBalance") && (
                <div className="jackpot-amount">
                  {this.getTotalPool(this.state.jackpotPool, game, false)}
                </div>
              )}
            </div>
            <div className="details">
              <div className="name">{game.get("name")}</div>
              <div className="provider">{game.get("provider")}</div>
              <div className="game-type">
                {game.get("gameType") ? game.get("gameType") : null}
              </div>
            </div>
            <div className="game-feature">
              {game.get("hasFreeRounds") && (
                <div className="game-feature-badge ribbonIcon">
                  <RibbonIcon color="rgba(255, 204, 0, 1)" />
                </div>
              )}
              {game.get("partOfOnGoingTournament") && (
                <div className="game-feature-badge trophyIcon">
                  <TrophyIcon color="rgba(255, 204, 0, 1)" />
                </div>
              )}
              {game.get("isJackpot") && (
                <div className="game-feature-badge jackpotIcon">
                  <CrownIcon color="rgba(255, 204, 0, 1)" />
                </div>
              )}
              {game.get("isFeatured") && (
                <div className="game-feature-badge editorsChoiceIcon">
                  <EditorsChoiceIcon color="rgba(255, 204, 0, 1)" />
                </div>
              )}
            </div>
            <div className="game-type">
              {game.get("gameType") ? null : <>&nbsp;</>}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default CategoryType2;
